module.exports = __webpack_public_path__ + "img/ewm.c6ebf874.png";